export default __webpack_public_path__ + "static/media/CarInsurance.9c41938a.jpg";